import { Widget } from '@typeform/embed-react'
import { ROUTE_PATH } from 'Routes';
import { ChangeHistory } from 'utils';




const Signup = (hidden) => {

 const queryparams=new URLSearchParams(document.location.search)
 let org=queryparams.get("org")
 let utm_campaign;
 let utm_content;
 let utm_medium;
 let utm_source;
 let utm_term;
 if(org){
  let splitOrg=org.split("?");
  org=splitOrg[0];
  if(splitOrg.length==2){
    const utmQueryParams= new URLSearchParams(splitOrg[1])
    utm_campaign=utmQueryParams.get("utm_campaign");
    utm_content=utmQueryParams.get("utm_content");
    utm_medium=utmQueryParams.get("utm_medium");
    utm_source=utmQueryParams.get("utm_source");
    utm_term=utmQueryParams.get("utm_term");
    // console.log(utmcampaign,utmcontent,utmmedium,utmsource,utmterm)
  }
 }
  // console.log(org)
 const email=queryparams.get("email");
 const authlink=queryparams.get("authlink");
 const form=queryparams.get("form");
//  console.log(form,"nbnbnbnn");
 if(!form){
  if(!org || !email || !authlink ){
   ChangeHistory("push",ROUTE_PATH.SAMPLES.LANDING)
  }
}

if(form){
  if(!authlink){
    ChangeHistory("push",ROUTE_PATH.SAMPLES.LANDING)
  }
  else {
    window.open(authlink,"_self");
  }
}

const ashwin={
  email,
  org,
  authlink,
  utm_campaign,
  utm_content,
  utm_medium,
  utm_source,
  utm_term
 }

  //Render UI
  return    <div  className="widget-typeform" style={{ width: '100%',height:'100%',background: '#FDF5D1' }}>
    <Widget id="cseEQRXY" style={{ width: '100%',height:'85vh' }} hidden={ashwin} inlineOnMobile={true} />
  </div>

};

export default Signup;
  